<template>
    <div class="modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Editar <strong>{{ username }}</strong></h5>
                    <button type="button" class="close" @click="closeModal">&times;</button>
                </div>
                <div class="modal-body">
                    <!-- Formulario para editar datos de usuario -->
                    <form @submit.prevent="handleSubmit">
                        <div v-if="!editingPassword">
                            <div class="form-group">
                                <label for="name-input">Nombre:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formEdit.name"
                                    id="name-input"
                                    required
                                />
                            </div>
                            <div class="form-group mt-2">
                                <label for="email-input">Correo electrónico:</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    v-model="formEdit.email"
                                    id="email-input"
                                    required
                                />
                            </div>
                        </div>
                        <div v-else>
                            <div class="form-group">
                                <label for="current_password-input">Contraseña actual:</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    v-model="formEdit.current_password"
                                    id="current_password-input"
                                    required
                                />
                            </div>
                            <div class="form-group mt-2">
                                <label for="new_password-input">Contraseña nueva:</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    v-model="formEdit.new_password"
                                    id="new_password-input"
                                    required
                                />
                            </div>
                            <div class="form-group mt-2">
                                <label for="password_confirmation-input">Confirmar contraseña:</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    v-model="formEdit.confirm_password"
                                    id="password_confirmation-input"
                                    required
                                />
                            </div>
                        </div>
                        <hr>
                        <div class="d-flex justify-content-end gap-1 mt-2">
                            <button type="button" class="btn btn-primary" @click="updatePassword">
                                {{ editingPassword ? "Editar usuario" : "Editar contraseña" }}
                            </button>
                            <button type="button" class="btn btn-danger mr-2" @click="closeModal">Cancelar</button>
                            <button class="btn btn-success" type="submit">Guardar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
    name: 'EditUserModal',
    props: {
        formEdit: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            editingPassword: false,
            username: this.formEdit.name,
        }
    },
    methods: {
        handleSubmit() {
            this.editingPassword ? this.editPassword() : this.editUser()
        },
        editUser() {
            axios.patch(`/api/user/admon/${this.formEdit.id}`, this.formEdit)
                .then(response => {
                    showCustomSuccessSweetAlert('Usuario editado correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        editPassword()
        {
            let formData = {
                passwordCurrent: this.formEdit.current_password,
                newPassword: this.formEdit.new_password,
                confirmPassword: this.formEdit.confirm_password,
            }
            axios.put(`/api/user/${this.formEdit.id}/update-password`, formData)
                .then(response => {
                    showCustomSuccessSweetAlert('Contraseña editada correctamente');
                    this.$emit('form-submitted');
                    this.closeModal();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        updatePassword() {
            this.editingPassword = !this.editingPassword;
        },
        closeModal() {
            this.$emit('close-modal');
        },
    }
}
</script>